var map = {
	"./administration/health-check-definition/health-check-definition.module.ngfactory": [
		"./src/app/administration/health-check-definition/health-check-definition.module.ngfactory.js",
		"administration-health-check-definition-health-check-definition-module-ngfactory"
	],
	"./advanced/contraction/contraction.module.ngfactory": [
		"./src/app/advanced/contraction/contraction.module.ngfactory.js",
		"advanced-contraction-contraction-module-ngfactory"
	],
	"./advanced/coreference-resolution/coreference-resolution.module.ngfactory": [
		"./src/app/advanced/coreference-resolution/coreference-resolution.module.ngfactory.js",
		"advanced-coreference-resolution-coreference-resolution-module-ngfactory"
	],
	"./advanced/non-dictionary-heuristics/non-dictionary-heuristics.module.ngfactory": [
		"./src/app/advanced/non-dictionary-heuristics/non-dictionary-heuristics.module.ngfactory.js",
		"advanced-non-dictionary-heuristics-non-dictionary-heuristics-module-ngfactory"
	],
	"./advanced/postprocessing/postprocessing.module.ngfactory": [
		"./src/app/advanced/postprocessing/postprocessing.module.ngfactory.js",
		"advanced-postprocessing-postprocessing-module-ngfactory"
	],
	"./advanced/pro-drop/pro-drop.module.ngfactory": [
		"./src/app/advanced/pro-drop/pro-drop.module.ngfactory.js",
		"advanced-pro-drop-pro-drop-module-ngfactory"
	],
	"./basic/edits-list/edits-list.module.ngfactory": [
		"./src/app/basic/edits-list/edits-list.module.ngfactory.js",
		"basic-edits-list-edits-list-module-ngfactory"
	],
	"./basic/user-profile/user-profile.module.ngfactory": [
		"./src/app/basic/user-profile/user-profile.module.ngfactory.js",
		"basic-user-profile-user-profile-module-ngfactory"
	],
	"./etymology/etymology.module.ngfactory": [
		"./src/app/etymology/etymology.module.ngfactory.js",
		"common",
		"etymology-etymology-module-ngfactory"
	],
	"./morphology/clitics/clitics.module.ngfactory": [
		"./src/app/morphology/clitics/clitics.module.ngfactory.js",
		"morphology-clitics-clitics-module-ngfactory"
	],
	"./morphology/default-feature-values/default-feature-values.module.ngfactory": [
		"./src/app/morphology/default-feature-values/default-feature-values.module.ngfactory.js",
		"morphology-default-feature-values-default-feature-values-module-ngfactory"
	],
	"./morphology/tagging-and-inflection/tagging-and-inflection.module.ngfactory": [
		"./src/app/morphology/tagging-and-inflection/tagging-and-inflection.module.ngfactory.js",
		"morphology-tagging-and-inflection-tagging-and-inflection-module-ngfactory"
	],
	"./syntax-and-context/common-cues/common-cues.module.ngfactory": [
		"./src/app/syntax-and-context/common-cues/common-cues.module.ngfactory.js",
		"default~syntax-and-context-common-cues-common-cues-module-ngfactory~syntax-and-context-phrasal-patte~1b93db98",
		"common",
		"syntax-and-context-common-cues-common-cues-module-ngfactory"
	],
	"./syntax-and-context/grammatical-agreement/grammatical-agreement.module.ngfactory": [
		"./src/app/syntax-and-context/grammatical-agreement/grammatical-agreement.module.ngfactory.js",
		"syntax-and-context-grammatical-agreement-grammatical-agreement-module-ngfactory"
	],
	"./syntax-and-context/phrasal-patterns/phrasal-patterns.module.ngfactory": [
		"./src/app/syntax-and-context/phrasal-patterns/phrasal-patterns.module.ngfactory.js",
		"default~syntax-and-context-common-cues-common-cues-module-ngfactory~syntax-and-context-phrasal-patte~1b93db98",
		"common",
		"syntax-and-context-phrasal-patterns-phrasal-patterns-module-ngfactory"
	],
	"./universal-components/element-clause-editor/element-clause-editor.module.ngfactory": [
		"./src/app/universal-components/element-clause-editor/element-clause-editor.module.ngfactory.js",
		"common",
		"universal-components-element-clause-editor-element-clause-editor-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;